const onlyNumbersFloat = (value) =>
  value.replace(/[^0-9.]/g, '').replace(/(\..*?)\..*/g, '$1')

export default onlyNumbersFloat
